module.exports = __webpack_public_path__ + "static/media/default_user.fea74962.png";